import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class SoccerTeamService {
    constructor(private http: HttpClient) {}

    list(): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}/soccer-teams`);
    }
}